export default {
  LOGS_URL: "logs",
};
